export default __webpack_public_path__ + "static/media/BpmJobs.ac269d8f2e892e42ee2fb84f3327092a.webp";